import { useLocation } from "wouter";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionCancel() {
  const [, setLocation] = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-12 max-w-md w-full text-center">
        <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <XCircle className="h-8 w-8 text-gray-400" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">No worries.</h1>
        <p className="text-gray-500 mb-8">
          You can subscribe to ClassTrack Pro anytime.
        </p>
        <div className="flex flex-col gap-3">
          <Button className="w-full" onClick={() => setLocation("/pricing")}>
            View pricing
          </Button>
          <Button variant="outline" className="w-full" onClick={() => setLocation("/app/dashboard")}>
            Back to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
